import { AxiosInstance, AxiosRequestConfig } from 'axios'

import {
  anonIdInterceptor,
  ApiClient,
  csrfTokenInterceptor,
} from '@marketplace-web/core-api/api-client-util'
import { useEnvs } from '@marketplace-web/environment/environment-util'
import { NEXT_HEADERS } from '@marketplace-web/vendor-abstractions/http-client-util/server'

import { ApiGatewayType, PLATFORM_HEADER_KEY } from '../constants'
import { isoLocaleInterceptor } from '../interceptors/iso-locale-interceptor'
import { resolveApiGatewayUrl } from '../utils/resolve-api-gateway-url'

export const useApiGatewayClient = (
  config: AxiosRequestConfig & { type?: ApiGatewayType } = {},
  interceptors: Array<((instance: AxiosInstance) => void) | undefined> = [],
) => {
  const serviceNameEnv = useEnvs('SERVICE_NAME')
  const shouldUseApiGatewayTransparentProxyEnv = useEnvs('SHOULD_USE_API_GATEWAY_TRANSPARENT_PROXY')

  const serviceName = serviceNameEnv ?? 'marketplace-web'
  const shouldUseTransparentProxy = Boolean(shouldUseApiGatewayTransparentProxyEnv)

  const apiClient = new ApiClient(
    {
      baseURL: resolveApiGatewayUrl(
        shouldUseTransparentProxy,
        config.type || ApiGatewayType.Default,
      ),
      withCredentials: true,
      headers: {
        [PLATFORM_HEADER_KEY]: 'web',
        [NEXT_HEADERS.X_NEXT_APP]: serviceName,
      },
      ...config,
    },
    [...interceptors, csrfTokenInterceptor, anonIdInterceptor, isoLocaleInterceptor],
  )

  return apiClient
}
